import { Link } from 'react-router-dom';
import fernandoPhoto from '../assets/me.jpg';
import Technologies from '../components/Technologies/Technologies';
import './Sobre.css';

function Sobre() {
  return (
    <div className="sobre-page">
      <div className="page-hero">
        <h1>Sobre</h1>
        <p>Desenvolvimento de software, integração e automação com foco em resultados.</p>
      </div>

      <section className="section">
        <div className="container sobre-grid">
          <div className="sobre-photo-wrap">
            <img src={fernandoPhoto} alt="Fernando Borelli" className="sobre-photo" />
          </div>

          <div className="sobre-content">
            <h2>Sou Fernando Borelli.</h2>
            <p>
              Há mais de 28 anos desenvolvo soluções para empresas.
            </p>
            <p>
              Minha experiência une desenvolvimento de software, integração de sistemas
              e automação de processos, sempre com foco em criar soluções que simplificam
              o dia a dia das organizações.
            </p>
            <p>
              Especializado em Java, Spring Boot, React, n8n e Inteligência Artificial,
              atuo em projetos corporativos que substituem planilhas, conectam sistemas
              e automatizam fluxos de trabalho.
            </p>

            <div className="sobre-stats">
              <div className="sobre-stat">
                <span className="stat-num">28+</span>
                <span className="stat-label">Anos de experiência</span>
              </div>
              <div className="sobre-stat">
                <span className="stat-num">100%</span>
                <span className="stat-label">Sob medida</span>
              </div>
              <div className="sobre-stat">
                <span className="stat-num">Direto</span>
                <span className="stat-label">Atendimento pessoal</span>
              </div>
            </div>

            <Link to="/contato" className="btn btn-primary">Entrar em contato</Link>
          </div>
        </div>
      </section>

      <Technologies />
    </div>
  );
}

export default Sobre;
